import { ITransformData } from "@base/math/TransformData";
import { IVec3, Vec3 } from "@base/math/Vec3";
import { IdGen } from "@base/util/IdGen";
import { ConfiguratorItemData } from "@biz/definitions/IVariantData3d";

export class CloneHelper {
  static getNewId(): string { return IdGen.unsecure.get() }

  static clone<T extends ConfiguratorItemData>(item: T, partial: Partial<T>, options?: { newId?: string; parentId?: string }): { item: T, children?: ConfiguratorItemData[] } {
    return {
      item: {
        ...item,
        id: options?.newId || CloneHelper.getNewId(),
        parentId: options?.parentId || item.parentId,
        ...partial
      },
    }
  }

  static moveTransform(transform: ITransformData, v: IVec3): ITransformData {
    return {
      ...transform,
      position: Vec3.add(transform.position, v)
    }
  }
}